import { directiveEntriesAdditionalDirectiveSteps } from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/constants/directiveEntriesAdditionalDirectiveSteps.constant'
import { MaintenanceForwardingsDirectiveEntryKlass } from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/constants/maintenanceForwardingsDirectiveEntryKlasses.type'
import { MaintenanceForwardingsRequiredDirectiveStepsData } from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/constants/maintenanceForwardingsShowDirectiveDetails.type'

export const buildRequiredDirectiveSteps = (
  directiveEntryType: string | undefined,
  requiredDirectiveSteps: MaintenanceForwardingsRequiredDirectiveStepsData | null,
) => {
  const additionalDirectiveSteps =
    directiveEntriesAdditionalDirectiveSteps[directiveEntryType as MaintenanceForwardingsDirectiveEntryKlass]

  if (!additionalDirectiveSteps) {
    return requiredDirectiveSteps
  }

  return {
    ...additionalDirectiveSteps.beforeRequiredDirectiveSteps.reduce((prev, curr) => ({ ...prev, [curr]: null }), {}),
    ...requiredDirectiveSteps,
    ...additionalDirectiveSteps.afterRequiredDirectiveSteps.reduce((prev, curr) => ({ ...prev, [curr]: null }), {}),
  }
}
